import { API_BASE ,axiosApi} from "../config"
import {
  GetProductsReturnInterface
} from "../types"



export const getProducts = async (): Promise<GetProductsReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/getProducts`)).data
}
